import { Link } from "react-router-dom";
import { featuredArticles } from "@/mocks/articles";

export default function HeroSection() {
  const topArticle = featuredArticles[0];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{ backgroundImage: `url(${topArticle.image})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col justify-end pb-10 md:pb-14">
        <div className="px-4 md:px-6 w-full">
          <div className="max-w-3xl">
            <Link
              to={`/category/${topArticle.category}`}
              className="inline-block mb-4 px-3 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium hover:bg-primary-500 transition-colors whitespace-nowrap"
            >
              {topArticle.categoryName}
            </Link>

            <Link to={`/article/${topArticle.id}`}>
              <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4 hover:opacity-90 transition-opacity">
                {topArticle.title}
              </h1>
            </Link>

            <p className="text-white/80 text-sm md:text-base leading-relaxed max-w-2xl mb-5 line-clamp-2">
              {topArticle.excerpt}
            </p>

            <div className="flex items-center gap-4 text-white/60 text-xs">
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line"></i>
                {topArticle.date}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {(topArticle.views / 10000).toFixed(1)}万阅读
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-chat-3-line"></i>
                {topArticle.comments}评论
              </span>
            </div>
          </div>

          <div className="hidden md:flex gap-3 mt-8">
            {featuredArticles.slice(1, 4).map((article, idx) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className={`group flex-1 rounded-lg overflow-hidden relative h-24 ${
                  idx === 1 ? "translate-y-2" : idx === 2 ? "-translate-y-1" : ""
                }`}
              >
                <div
                  className="absolute inset-0 bg-cover bg-center"
                  style={{ backgroundImage: `url(${article.image})` }}
                >
                  <div className="absolute inset-0 bg-black/55 group-hover:bg-black/40 transition-colors"></div>
                </div>
                <div className="relative z-10 p-3 h-full flex flex-col justify-end">
                  <span className="text-white/90 text-xs font-medium line-clamp-2 leading-snug">
                    {article.title}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}